<template>
  <Minimal>
    <el-container class="h-screen">
      <!-- 移动端菜单 -->
      <MobileMenu v-if="isMobile" v-model:visible="isDrawerVisible" v-model:current-menu="currentMenu" v-model:current-sub-menu="currentSubMenu" />

      <!-- 桌面端菜单 -->
      <DesktopMenu v-if="!isMobile" v-model:current-menu="currentMenu" v-model:current-sub-menu="currentSubMenu"/>

      <!-- 主要内容区域 -->
      <el-container>
        <el-header class="h-[50px]! border-b border-gray-100 py-[10px]! px-[20px]!">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <el-button v-if="isMobile" link @click="toggleMobileMenu">
                <template #icon><el-icon><Menu /></el-icon></template>
              </el-button>
              <el-breadcrumb :separator="'/'">
                <el-breadcrumb-item>{{ currentMenu?.name }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentSubMenu?.name }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <UserDropdown :user="currentUser" />
          </div>
        </el-header>
        <el-main class="!p-[20px] h-[calc(100vh-50px)] overflow-y-auto">
          <slot />
        </el-main>
      </el-container>

      <el-drawer v-model="visible" :with-header="false" size="calc(100vw - 210px)" class="layout-drawer !h-[calc(100vh - 40px)]" :destroy-on-close="false">
        <template #default>
          <slot name="drawer" />
        </template>
        <!-- <el-skeleton :loading="drawerLoading" animated class="!w-full !h-[calc(100vh-50px)]">
          
          <template #template>
            <div class="flex justify-center items-center h-full w-full">
              <el-skeleton-item variant="p" style="width: 100%; height: 100%" />
            </div>
          </template>
        </el-skeleton> -->
      </el-drawer>
    </el-container>
  </Minimal>
</template>

<script setup>
import useShareData from "@/hooks/useShareData"
import UserDropdown from "@/components/layout/UserDropdown.vue"
import MobileMenu from "@/components/layout/MobileMenu.vue"
import DesktopMenu from "@/components/layout/DesktopMenu.vue"
import { Menu } from '@element-plus/icons-vue'
import Minimal from '@/layouts/Minimal.vue'

const { t } = useI18n()
const { currentUser } = useShareData()
const currentMenu = ref({})
const currentSubMenu = ref({})
const visible = ref(false)
const drawerLoading = ref(false)
// 响应式状态
const isMobile = ref(false)
const isTablet = ref(false)
const isDrawerVisible = ref(false)

// 检查设备类型
const checkDeviceType = () => {
  const width = window.innerWidth
  isMobile.value = width < 768
  isTablet.value = width >= 768 && width < 1024
  
  // 在移动端时自动隐藏菜单
  if (isMobile.value) isDrawerVisible.value = false
}

// 移动端菜单切换
const toggleMobileMenu = () => {
  if (isMobile.value) isDrawerVisible.value = !isDrawerVisible.value
}

// 监听窗口大小变化
onMounted(() => {
  checkDeviceType()
  window.addEventListener('resize', checkDeviceType)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkDeviceType)
})

// 抽屉控制方法
const openDrawer = () => {
  visible.value = true
  drawerLoading.value = true
}

const closeDrawer = () => {
  visible.value = false
  drawerLoading.value = false
}

const stopDrawerLoading = () => {
  drawerLoading.value = false
}

defineExpose({ openDrawer, closeDrawer, stopDrawerLoading })
</script>

<style>
@reference "../entrypoints/application.css";

.layout-drawer .el-drawer__header {
  @apply !py-[8px] px-[20px] border-b;
  margin: 0;
}

.layout-drawer .el-drawer__body {
  @apply !p-[0px] !h-[calc(100vh-140px)];
}
</style>
